import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { VESSEL_TYPES } from "@/lib/constants";
import { Section, Field } from "./fields";

export const JobVesselSection = ({ form, update, orders, vesselNumberOptional, fp = () => ({}) }) => (
  <Section title="Job & vessel" number="01">
    <Field label="Job / Freezer number *" {...fp("job_number")}>
      <Select
        value={form.job_number || ""}
        onValueChange={(v) => v && update({ job_number: v })}
      >
        <SelectTrigger data-testid="job-number-select" className="border-[#33424f]/30">
          <SelectValue placeholder="Select order…" />
        </SelectTrigger>
        <SelectContent>
          {form.job_number &&
            !orders.some((o) => o.job_number === form.job_number) && (
              <SelectItem value={form.job_number}>{form.job_number}</SelectItem>
            )}
          {orders
            .filter((o) => o.job_number)
            .filter((o) => o.active !== false || o.job_number === form.job_number)
            .map((o) => (
              <SelectItem key={o.id} value={o.job_number}>
                {o.description ? `${o.job_number} — ${o.description}` : o.job_number}
              </SelectItem>
            ))}
        </SelectContent>
      </Select>
    </Field>

    <Field label="Vessel type *" {...fp("vessel_type")}>
      <Select
        value={form.vessel_type || ""}
        onValueChange={(v) => {
          if (!v) return; // ignore spurious empty events (no valid empty vessel type)
          // Switching INTO Freezer Assembly clears any welder selections (FA tests have no welds).
          if (v === "Freezer Assembly") {
            update({ vessel_type: v, welder1_id: "", welder2_id: "" });
          } else {
            update({ vessel_type: v });
          }
        }}
      >
        <SelectTrigger data-testid="vessel-type-select" className="border-[#33424f]/30">
          <SelectValue placeholder="Select type…" />
        </SelectTrigger>
        <SelectContent>
          {VESSEL_TYPES.map((v) => (
            <SelectItem key={v} value={v}>{v}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>

    <Field label={vesselNumberOptional ? "Vessel number (auto-assigned)" : "Vessel number *"} {...fp("vessel_number")}>
      <Input
        data-testid="vessel-number-input"
        type="number"
        min="0"
        step="1"
        required={!vesselNumberOptional}
        value={form.vessel_number}
        onChange={(e) => update({ vessel_number: e.target.value })}
        className="border-[#33424f]/30"
        placeholder={vesselNumberOptional ? "Leave blank to auto-assign next #" : "e.g. 12"}
      />
    </Field>
  </Section>
);
